export default {
      id: "bb_sesong-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "/gfx/iconset.13.17.6.svg#bb_sesong",
      toString: function () {
        return this.url;
      }
    }